import { render, staticRenderFns } from "./EditBeneficiary.vue?vue&type=template&id=f841cf6a&scoped=true"
import script from "./EditBeneficiary.vue?vue&type=script&lang=ts"
export * from "./EditBeneficiary.vue?vue&type=script&lang=ts"
import style0 from "./EditBeneficiary.vue?vue&type=style&index=0&id=f841cf6a&prod&lang=scss&scoped=true"
import style1 from "./EditBeneficiary.vue?vue&type=style&index=1&id=f841cf6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f841cf6a",
  null
  
)

export default component.exports